export default {"src":"/_next/static/media/BRITISH_AIRWAYS.ea41262c.ico","height":32,"width":32,"blurWidth":0,"blurHeight":0};